import type { HeroSlide } from "@/types/content";

export const heroSlides: HeroSlide[] = [
  {
    id: "slide-1",
    title: "星辰之下",
    subtitle: "年度科幻巨制 · 穿越星空的旅程",
    tagline: "当深空的信号传来，人类的答案才刚刚开始。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20hero%20illustration%20of%20a%20vast%20starry%20night%20sky%20over%20a%20glowing%20observatory%20on%20a%20silent%20plain%2C%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20dramatic%20atmospheric%20lighting%2C%20epic%20sci-fi%20mood%2C%20no%20text&width=1600&height=720&seq=hp-slide-01&orientation=landscape",
    link: "/detail/xingchen-zhixia",
    badge: "热播推荐",
  },
  {
    id: "slide-2",
    title: "长夜将明",
    subtitle: "年度口碑剧王 · 时代洪流中的坚守",
    tagline: "三十年光阴，写尽普通人与家国的共同命运。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20hero%20illustration%20of%20a%20nostalgic%20old%20town%20street%20at%20dawn%20with%20warm%20golden%20sunrise%20light%20and%20lone%20silhouette%2C%20amber%20and%20teal%20palette%2C%20historical%20drama%20epic%20mood%2C%20no%20text&width=1600&height=720&seq=hp-slide-02&orientation=landscape",
    link: "/detail/changye-jiangming",
    badge: "9.1 高分",
  },
  {
    id: "slide-3",
    title: "极夜行动",
    subtitle: "谍战新标杆 · 极昼极夜里的暗战",
    tagline: "身份随时可能暴露，任务却只许成功。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20hero%20illustration%20of%20a%20snowy%20border%20town%20under%20aurora%20night%20sky%20with%20a%20lone%20agent%20silhouette%2C%20cold%20blue%20and%20warm%20amber%20contrast%2C%20tense%20espionage%20mood%2C%20no%20text&width=1600&height=720&seq=hp-slide-03&orientation=landscape",
    link: "/detail/jiye-xingdong",
    badge: "口碑爆款",
  },
  {
    id: "slide-4",
    title: "都市迷案",
    subtitle: "悬疑刑侦 · 抽丝剥茧揭开真相",
    tagline: "每一个案件背后，都藏着同一个答案。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20hero%20illustration%20of%20a%20neon-lit%20modern%20city%20at%20night%20with%20rain-slicked%20streets%20and%20sprawling%20skyline%2C%20deep%20blue%20and%20orange%20neon%20tones%2C%20tense%20crime%20drama%20mood%2C%20no%20text&width=1600&height=720&seq=hp-slide-04&orientation=landscape",
    link: "/detail/dushi-mian",
    badge: "正在热播",
  },
];

export const categoryEntries = [
  { key: "movie", label: "电影", desc: "院线新片与经典佳作", icon: "ri-film-line" },
  { key: "tv", label: "电视剧", desc: "热播剧集与年度剧王", icon: "ri-tv-2-line" },
  { key: "recommend", label: "本周推荐", desc: "编辑精选必看片单", icon: "ri-fire-line" },
  { key: "news", label: "影视资讯", desc: "最新动态一手掌握", icon: "ri-newspaper-line" },
  { key: "hot", label: "热播榜单", desc: "人气飙升影视排行", icon: "ri-bar-chart-box-line" },
];

export const genreOptions = [
  "全部",
  "剧情",
  "科幻",
  "悬疑",
  "爱情",
  "动作",
  "喜剧",
  "惊悚",
  "犯罪",
  "历史",
  "武侠",
  "青春",
  "家庭",
];

export const regionOptions = [
  "全部",
  "中国大陆",
  "中国香港",
  "美国",
  "日本",
  "韩国",
  "英国",
  "法国",
];

export const yearOptions = ["全部", "2025", "2024", "2023", "更早"];